import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { getVentesByIdsPromise } from '../../flux/actions/venteActions';
import { getAssociationsByIdsPromise } from '../../flux/actions/associationActions';
import { getEncaissementsByIdsPromise } from '../../flux/actions/encaissementActions';
import { IAuthReduxProps, IBudgetTable, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import VenteListModal from '../modals/VenteListModal';
import EncaissementListModal from '../modals/EncaissementListModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import { getColorBudget } from '../../services/misc';
import Loading from '../Loading';

const BudgetTable = ({ 
  linesData,
  budgets,
  month,
  budgetType,
  encaissements,
  loadingV,
  loadingA,
  loadingE,
 }: IBudgetTable) => {
  const [modalV, setModalV] = useState(false);
  const [modalE, setModalE] = useState(false);
  const [listVv, setListVv] = useState<any[]>([]);
  const [listVa, setListVa] = useState<any[]>([]);
  const [listE, setListE] = useState<any[]>([]);
  const [loadingVv, setLoadingVv] = useState(false);
  const [loadingVa, setLoadingVa] = useState(false);

  const getVv = (ids) => {
    setListVv([])
    setLoadingVv(true)
    getVentesByIdsPromise(ids || [])
    .then(e => setListVv(e || []))
    .finally(() => setLoadingVv(false))
  };

  const getVa = (ids) => {
    setListVa([])
    setLoadingVa(true)
    getAssociationsByIdsPromise(ids || [])
    .then(e => setListVa(e || []))
    .finally(() => setLoadingVa(false))
  };

  // const getE = (ids) => {
  //   setListE([])
  //   setLoadingE(true)
  //   getEncaissementsByIdsPromise(ids || [])
  //   .then(e => setListE(e || []))
  //   .finally(() => setLoadingE(false))
  // };

  const getE = (ids) => {
    setListE(encaissements.filter(e => e.id && (ids || []).includes(e.id)))
  };

  const columnsV = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      {
        Header: "Objectifs Ventes",
        columns: [
          {
            Header: constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                accessor: "sPrixNet",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getVv(original.vIds?.venteIds || []); getVa(original.vIds?.assIds || []); setModalV(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                accessor: "goalV",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                accessor: e => e.goalV ? Number(e.sPrixNet || 0) - Number(e.goalV || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                accessor: e => e.goalV ? Math.ceil((Number(e.sPrixNet || 0) * 100) / Number(e.goalV || 0)) : 0,
                //custom export..
                disableFilters: true,
                className: "tableCellRightBorder text-right",
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
          {
            Header: "Cumul à fin " + constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                id: "C Réalisé",
                accessor: "sPrixNetT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getVv(original.vIdsT?.venteIds || []); getVa(original.vIdsT?.assIds || []); setModalV(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                id: "C Budget",
                accessor: "goalVT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                id: "C Écart",
                accessor: e => e.goalVT ? Number(e.sPrixNetT || 0) - Number(e.goalVT || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                id: "C %",
                accessor: e => e.goalVT ? Math.ceil((Number(e.sPrixNetT || 0) * 100) / Number(e.goalVT || 0)) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
        ]
      }
    ],
    [month, budgetType]
  )

  const columnsE = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      {
        Header: "Objectifs Encaissements Ventes",
        columns: [
          {
            Header: constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                accessor: "sEncaissements",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.eIds || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                accessor: "goalE",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                accessor: e => e.goalE ? Number(e.sEncaissements || 0) - Number(e.goalE || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                accessor: e => e.goalE ? Math.ceil((Number(e.sEncaissements || 0) * 100) / Number(e.goalE || 0)) : 0,
                //custom export..
                disableFilters: true,
                className: "tableCellRightBorder text-right",
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
          {
            Header: "Cumul à fin " + constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                id: "C Réalisé",
                accessor: "sEncaissementsT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.eIdsT || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                id: "C Budget",
                accessor: "goalET",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                id: "C Écart",
                accessor: e => e.goalET ? Number(e.sEncaissementsT || 0) - Number(e.goalET || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                id: "C %",
                accessor: e => e.goalET ? Math.ceil((Number(e.sEncaissementsT || 0) * 100) / Number(e.goalET || 0)) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
        ]
      }
    ],
    [month, budgetType, encaissements?.length]
  )

  const columnsR = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      {
        Header: "Objectifs Recouvrement",
        columns: [
          {
            Header: constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                accessor: "sRecouvrement",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.rIds || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                accessor: "goalR",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                accessor: e => e.goalR ? Number(e.sRecouvrement || 0) - Number(e.goalR || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                accessor: e => e.goalR ? Math.ceil((Number(e.sRecouvrement || 0) * 100) / Number(e.goalR || 0)) : 0,
                //custom export..
                disableFilters: true,
                className: "tableCellRightBorder text-right",
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
          {
            Header: "Cumul à fin " + constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                id: "C Réalisé",
                accessor: "sRecouvrementT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.rIdsT || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                id: "C Budget",
                accessor: "goalRT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                id: "C Écart",
                accessor: e => e.goalRT ? Number(e.sRecouvrementT || 0) - Number(e.goalRT || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                id: "C %",
                accessor: e => e.goalRT ? Math.ceil((Number(e.sRecouvrementT || 0) * 100) / Number(e.goalRT || 0)) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
        ]
      }
    ],
    [month, budgetType, encaissements?.length]
  )

  const columnsER = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      {
        Header: "Objectifs Encaissements Ventes + Recouvrement",
        columns: [
          {
            Header: constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                accessor: "sER",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.erIds || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                accessor: "goalER",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                accessor: e => e.goalER ? Number(e.sER || 0) - Number(e.goalER || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                accessor: e => e.goalER ? Math.ceil((Number(e.sER || 0) * 100) / Number(e.goalER || 0)) : 0,
                //custom export..
                disableFilters: true,
                className: "tableCellRightBorder text-right",
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
          {
            Header: "Cumul à fin " + constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                id: "C Réalisé",
                accessor: "sERT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getE(original.erIdsT || []); setModalE(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                id: "C Budget",
                accessor: "goalERT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                id: "C Écart",
                accessor: e => e.goalERT ? Number(e.sERT || 0) - Number(e.goalERT || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                id: "C %",
                accessor: e => e.goalERT ? Math.ceil((Number(e.sERT || 0) * 100) / Number(e.goalERT || 0)) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
        ]
      }
    ],
    [month, budgetType, encaissements?.length]
  )

  const columnsL = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn text-left",
        disableSortBy: true,
        Cell: ({ value, row: {original} }) => value
      },
      {
        Header: "Objectifs Livraison",
        columns: [
          {
            Header: constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                accessor: "sLivraison",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getVv(original.lIds || []); getVa([]); setModalV(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                accessor: "goalL",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                accessor: e => e.goalL ? Number(e.sLivraison || 0) - Number(e.goalL || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                accessor: e => e.goalL ? Math.ceil((Number(e.sLivraison || 0) * 100) / Number(e.goalL || 0)) : 0,
                //custom export..
                disableFilters: true,
                className: "tableCellRightBorder text-right",
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
          {
            Header: "Cumul à fin " + constants.DP_MONTHS[month - 1],
            columns: [
              {
                Header: "Réalisé",
                id: "C Réalisé",
                accessor: "sLivraisonT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value, row: {original} }) => <div style={{whiteSpace: "nowrap", position: "relative", paddingRight: 25}}>{value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate"}} onClick={() => {getVv(original.lIdsT || []); getVa([]); setModalV(true);}} /></div>
              },
              {
                Header: budgetType === "goal" ? "Objectif Com." : "Budget",
                id: "C Budget",
                accessor: "goalLT",
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "Écart",
                id: "C Écart",
                accessor: e => e.goalLT ? Number(e.sLivraisonT || 0) - Number(e.goalLT || 0) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => value ? `${value.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"
              },
              {
                Header: "%",
                id: "C %",
                accessor: e => e.goalLT ? Math.ceil((Number(e.sLivraisonT || 0) * 100) / Number(e.goalLT || 0)) : 0,
                //custom export..
                className: "text-right",
                disableFilters: true,
                Cell: ({ value }) => <div className="encPercent" style={{color: getColorBudget(value)}}>
                  {`${value} %`}
                </div>
              },
            ]
          },
        ]
      }
    ],
    [month, budgetType]
  )

  return (
    <div>
      <Container>
        {loadingV || loadingA ? <Loading /> : <TableContainer columns={columnsV} data={linesData.map(e => {
          const concernedMonths = [...Array(month).keys()].map(t => e[t + 1])
          return {
            ...e,
            ...(e.projectId === "ALL" ? {customStyle: {boxShadow: "inset 10px 0px 5px 1px #45772e"}} : {}),
            sPrixNet: Number(e[month].sPrixNet || 0),
            goalV: budgetType === "goal" ? Number(e[month].goalV2 || 0) : Number(e[month].goalV || 0),
            sPrixNetT: concernedMonths.reduce((e, t) => e + Number(t.sPrixNet || 0), 0),
            goalVT: concernedMonths.reduce((e, t) => e + (budgetType === "goal" ? Number(t.goalV2 || 0) : Number(t.goalV || 0)), 0),
            vIds: e[month].vIds,
            vIdsT: {venteIds: concernedMonths.reduce((e, t) => [...e, ...(t.vIds?.venteIds || [])], []), assIds: concernedMonths.reduce((e, t) => [...e, ...(t.vIds?.assIds || [])], [])},
          }
        })} enableCheckBox={false} showPagination={false} isEditable={false} bgColor="#45772e" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>}
        {loadingE ? <Loading /> : <>
          <TableContainer columns={columnsE} data={linesData.map(e => {
            const concernedMonths = [...Array(month).keys()].map(t => e[t + 1])
            return {
              ...e,
              ...(e.projectId === "ALL" ? {customStyle: {boxShadow: "inset 10px 0px 5px 1px #2a739f"}} : {}),
              sEncaissements: Number(e[month].sEncaissements || 0),
              goalE: budgetType === "goal" ? Number(e[month].goalE2 || 0) : Number(e[month].goalE || 0),
              sEncaissementsT: concernedMonths.reduce((e, t) => e + Number(t.sEncaissements || 0), 0),
              goalET: concernedMonths.reduce((e, t) => e + (budgetType === "goal" ? Number(t.goalE2 || 0) : Number(t.goalE || 0)), 0),
              eIds: e[month].eIds,
              eIdsT: concernedMonths.reduce((e, t) => [...e, ...(t.eIds || [])], []),
            }
          })} enableCheckBox={false} showPagination={false} isEditable={false} bgColor="#2a739f" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
          <TableContainer columns={columnsR} data={linesData.map(e => {
            const concernedMonths = [...Array(month).keys()].map(t => e[t + 1])
            return {
              ...e,
              ...(e.projectId === "ALL" ? {customStyle: {boxShadow: "inset 10px 0px 5px 1px cornflowerblue"}} : {}),
              sRecouvrement: Number(e[month].sRecouvrement || 0),
              goalR: budgetType === "goal" ? Number(e[month].goalR2 || 0) : Number(e[month].goalR || 0),
              sRecouvrementT: concernedMonths.reduce((e, t) => e + Number(t.sRecouvrement || 0), 0),
              goalRT: concernedMonths.reduce((e, t) => e + (budgetType === "goal" ? Number(t.goalR2 || 0) : Number(t.goalR || 0)), 0),
              rIds: e[month].rIds,
              rIdsT: concernedMonths.reduce((e, t) => [...e, ...(t.rIds || [])], []),
            }
          })} enableCheckBox={false} showPagination={false} isEditable={false} bgColor="cornflowerblue" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
          <TableContainer columns={columnsER} data={linesData.filter(e => e.projectId === "ALL").map(e => {
            const concernedMonths = [...Array(month).keys()].map(t => e[t + 1])
            return {
              ...e,
              sER: Number(e[month].sEncaissements || 0) + Number(e[month].sRecouvrement || 0),
              goalER: budgetType === "goal" ? (Number(e[month].goalE2 || 0) + Number(e[month].goalR2 || 0)) : (Number(e[month].goalE || 0) + Number(e[month].goalR || 0)),
              sERT: concernedMonths.reduce((e, t) => e + Number(t.sEncaissements || 0) + Number(t.sRecouvrement || 0), 0),
              goalERT: concernedMonths.reduce((e, t) => e + (budgetType === "goal" ? Number(t.goalE2 || 0) : Number(t.goalE || 0)) + (budgetType === "goal" ? Number(t.goalR2 || 0) : Number(t.goalR || 0)), 0),
              erIds: [...(e[month].eIds || []), ...(e[month].rIds || [])],
              erIdsT: concernedMonths.reduce((e, t) => [...e, ...(t.eIds || []), ...(t.rIds || [])], []),
            }
          })} enableCheckBox={false} showPagination={false} isEditable={false} bgColor="darkslateblue" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
        </>}
        {loadingV || loadingA ? <Loading /> : <TableContainer columns={columnsL} data={linesData.map(e => {
            const concernedMonths = [...Array(month).keys()].map(t => e[t + 1])
            return {
              ...e,
              ...(e.projectId === "ALL" ? {customStyle: {boxShadow: "inset 10px 0px 5px 1px darkslategray"}} : {}),
              sLivraison: Number(e[month].sLivraison || 0),
              goalL: budgetType === "goal" ? Number(e[month].goalL2 || 0) : Number(e[month].goalL || 0),
              sLivraisonT: concernedMonths.reduce((e, t) => e + Number(t.sLivraison || 0), 0),
              goalLT: concernedMonths.reduce((e, t) => e + (budgetType === "goal" ? Number(t.goalL2 || 0) : Number(t.goalL || 0)), 0),
              lIds: e[month].lIds,
              lIdsT: concernedMonths.reduce((e, t) => [...e, ...(t.lIds || [])], []),
            }
          })} enableCheckBox={false} showPagination={false} isEditable={false} bgColor="darkslategray" hideFiltersByDefault smallerCols centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>}
      </Container>
      <VenteListModal modal={modalV} setModal={setModalV} lines={[...listVv, ...listVa.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
        if(!a.createdAt && !b.createdAt)
          return 0
        else if(!a.createdAt)
          return 1
        else if(!b.createdAt)
          return -1
        else
          return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
      })} linesLoading={loadingVv || loadingVa} />
      <EncaissementListModal modal={modalE} setModal={setModalE} lines={listE} />
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(BudgetTable);
